import * as d3 from 'd3';
import { RectFormat } from '../../charts/interfaces';
import { Format } from './Format';
import { LineChartData } from '../../../models/LineChartData';

const line = d3.svg.line<RectFormat<LineChartData>>()
    .defined(d => d.item.value !== null)
    .x(d => d.x)
    .y(d => (d.item.value < 0) ? d.y + d.height : d.y);

export function renderStackedLines(
    container: d3.Selection<RectFormat<LineChartData>>,
    series: Format[]
): void {
    const dataBound = container
        .selectAll('.line')
        .data(series.filter(r => r.series.isLineVisible()));
    dataBound
        .exit()
        .remove();
    dataBound
        .enter()
        .append('path')
        .classed('series-container', true)
        .attr('data-identifier', s => 'id' + s.series.identifier())
        .classed('line', true)
        .classed('trend', true);
    dataBound
        .classed('hidden', d => !d.series.isVisible());
    dataBound
        .attr('d', d => line(d.data))
        .style('stroke', d => d.series.color());
}